<div class="aca-pdfstudio">
  <!-- tools row -->
  <div class="aca-pdfstudio__tools">
    <button
      type="button"
      class="aca-pdftool"
      [class.aca-pdftool--on]="isTool('select')"
      (click)="arm('select')"
      [matTooltip]="'DMS.PDFTOOLS.SELECT' | translate"
    >
      <mat-icon>near_me</mat-icon><span>{{ 'DMS.PDFTOOLS.SELECT' | translate }}</span>
    </button>
    <button
      type="button"
      class="aca-pdftool"
      [class.aca-pdftool--on]="isTool('pan')"
      (click)="arm('pan')"
      [matTooltip]="'DMS.PDFTOOLS.PAN' | translate"
    >
      <mat-icon>pan_tool</mat-icon><span>{{ 'DMS.PDFTOOLS.PAN' | translate }}</span>
    </button>

    <span class="aca-pdfstudio__sep"></span>

    <button
      mat-icon-button
      (click)="undo()"
      [disabled]="!canUndo()"
      [matTooltip]="'DMS.PDFTOOLS.UNDO' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.UNDO' | translate"
    >
      <mat-icon>undo</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="redo()"
      [disabled]="!canRedo()"
      [matTooltip]="'DMS.PDFTOOLS.REDO' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.REDO' | translate"
    >
      <mat-icon>redo</mat-icon>
    </button>

    <span class="aca-pdfstudio__sep"></span>

    <button
      mat-icon-button
      (click)="zoomOut()"
      [matTooltip]="'DMS.PDFTOOLS.ZOOM_OUT' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.ZOOM_OUT' | translate"
    >
      <mat-icon>remove</mat-icon>
    </button>
    <button type="button" class="aca-pdfstudio__zoomval" [matMenuTriggerFor]="zoomMenu">{{ zoom() * 100 | number: '1.0-0' }}%</button>
    <mat-menu #zoomMenu="matMenu">
      <button mat-menu-item *ngFor="let z of [0.5, 0.75, 1, 1.25, 1.5, 2]" (click)="setZoom(z)">{{ z * 100 }}%</button>
    </mat-menu>
    <button
      mat-icon-button
      (click)="zoomIn()"
      [matTooltip]="'DMS.PDFTOOLS.ZOOM_IN' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.ZOOM_IN' | translate"
    >
      <mat-icon>add</mat-icon>
    </button>
    <button type="button" class="aca-pdftool" (click)="fit(true)">
      <mat-icon>fit_screen</mat-icon><span>{{ 'DMS.PDFTOOLS.FIT_WIDTH' | translate }}</span>
    </button>
    <button type="button" class="aca-pdftool" (click)="fit(false)">
      <mat-icon>crop_free</mat-icon><span>{{ 'DMS.PDFTOOLS.FIT_PAGE' | translate }}</span>
    </button>

    <span class="aca-pdfstudio__sep"></span>

    <button type="button" class="aca-pdftool" (click)="toggleSearch()">
      <mat-icon>search</mat-icon><span>{{ 'DMS.PDFTOOLS.SEARCH' | translate }}</span>
    </button>

    <span class="aca-pdfstudio__sep"></span>

    <!-- the grouped tools menu -->
    <button type="button" class="aca-pdftool aca-pdftool--menu" [class.aca-pdftool--on]="toolsOpen()" (click)="toolsOpen.set(!toolsOpen())">
      <mat-icon>more_horiz</mat-icon><span>{{ 'DMS.PDFTOOLS.MORE' | translate }}</span
      ><mat-icon class="aca-pdfstudio__caret">expand_more</mat-icon>
    </button>

    <span class="aca-pdfstudio__flex"></span>

    <span class="aca-pdfstudio__dirty" *ngIf="dirty()"><mat-icon>edit</mat-icon>{{ 'DMS.PDFTOOLS.UNSAVED' | translate }}</span>
    <button
      type="button"
      class="aca-pdfstudio__save"
      *ngIf="canWrite"
      [disabled]="busy() || !dirty()"
      [matMenuTriggerFor]="saveMenu"
      [matTooltip]="dirty() ? '' : ('DMS.PDFTOOLS.SAVE_HINT' | translate)"
    >
      <mat-icon>save</mat-icon>{{ 'DMS.PDFTOOLS.SAVE' | translate }}<mat-icon class="aca-pdfstudio__caret">expand_more</mat-icon>
    </button>
    <mat-menu #saveMenu="matMenu">
      <button mat-menu-item (click)="save(true)"><mat-icon>publish</mat-icon>{{ 'DMS.PDFTOOLS.SAVE_MAJOR' | translate }}</button>
      <button mat-menu-item (click)="save(false)"><mat-icon>arrow_upward</mat-icon>{{ 'DMS.PDFTOOLS.SAVE_MINOR' | translate }}</button>
      <mat-divider />
      <button mat-menu-item (click)="discard()" [disabled]="!dirty()"><mat-icon>undo</mat-icon>{{ 'DMS.PDFTOOLS.DISCARD' | translate }}</button>
    </mat-menu>
  </div>

  <!-- digital signatures in the stored version -->
  <div class="aca-pdfsig" *ngIf="signatureSummary() as summary" [class]="'aca-pdfsig aca-pdfsig--' + summary">
    <button type="button" class="aca-pdfsig__bar" (click)="signaturesOpen.set(!signaturesOpen())" [attr.aria-expanded]="signaturesOpen()">
      <mat-icon>{{ summary === 'broken' ? 'gpp_bad' : summary === 'unknown' ? 'gpp_maybe' : 'verified_user' }}</mat-icon>
      <span>{{ 'DMS.PDFTOOLS.DS_BAR_' + (summary | uppercase) | translate: { p0: signatures()?.length } }}</span>
      <mat-icon class="aca-pdfstudio__caret">{{ signaturesOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <ul class="aca-pdfsig__list" *ngIf="signaturesOpen()">
      <li *ngFor="let s of signatures()" [class]="'aca-pdfsig__item aca-pdfsig__item--' + stateOf(s)">
        <mat-icon>{{ stateOf(s) === 'broken' ? 'gpp_bad' : stateOf(s) === 'unknown' ? 'gpp_maybe' : 'verified_user' }}</mat-icon>
        <div>
          <strong>{{ s.name || s.signer || s.field }}</strong>
          <span *ngIf="s.signedAt"> · {{ s.signedAt | acaDate: 'd MMM y HH:mm' }}</span>
          <span *ngIf="s.reason"> · {{ s.reason }}</span>
          <div class="aca-pdfsig__state">{{ 'DMS.PDFTOOLS.DS_STATE_' + (stateOf(s) | uppercase) | translate: { p0: s.signer || '' } }}</div>
        </div>
      </li>
    </ul>
  </div>

  <!-- search bar -->
  <div class="aca-pdfstudio__search" *ngIf="searchOpen">
    <mat-icon>search</mat-icon>
    <input
      [(ngModel)]="searchTerm"
      (ngModelChange)="runSearch()"
      (keyup.enter)="nextHit(1)"
      [placeholder]="'DMS.PDFTOOLS.SEARCH_PH' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.SEARCH_PH' | translate"
    />
    <span class="aca-pdfstudio__hits">{{ searchHits().length ? searchIndex() + 1 + ' / ' + searchHits().length : '0 / 0' }}</span>
    <button mat-icon-button (click)="nextHit(-1)" [disabled]="!searchHits().length"><mat-icon>keyboard_arrow_up</mat-icon></button>
    <button mat-icon-button (click)="nextHit(1)" [disabled]="!searchHits().length"><mat-icon>keyboard_arrow_down</mat-icon></button>
    <button mat-icon-button (click)="toggleSearch()"><mat-icon>close</mat-icon></button>
  </div>

  <!-- the tools menu panel -->
  <div class="aca-pdfmenu" *ngIf="toolsOpen()" (mouseleave)="toolsOpen.set(false)">
    <div class="aca-pdfmenu__col">
      <h4>{{ 'DMS.PDFTOOLS.G_MARKUP' | translate }}</h4>
      <button type="button" (click)="arm('highlight')"><mat-icon>border_color</mat-icon>{{ 'DMS.PDFTOOLS.HIGHLIGHT' | translate }}</button>
      <button type="button" (click)="arm('underline')"><mat-icon>format_underlined</mat-icon>{{ 'DMS.PDFTOOLS.UNDERLINE' | translate }}</button>
      <button type="button" (click)="arm('strike')"><mat-icon>strikethrough_s</mat-icon>{{ 'DMS.PDFTOOLS.STRIKE' | translate }}</button>
      <button type="button" (click)="arm('textbox')"><mat-icon>text_fields</mat-icon>{{ 'DMS.PDFTOOLS.TEXTBOX' | translate }}</button>
      <button type="button" (click)="arm('note')"><mat-icon>chat_bubble_outline</mat-icon>{{ 'DMS.PDFTOOLS.NOTE' | translate }}</button>
      <button type="button" (click)="arm('ink')"><mat-icon>draw</mat-icon>{{ 'DMS.PDFTOOLS.DRAW' | translate }}</button>
      <button type="button" class="aca-pdfmenu__has-sub" (click)="$event.stopPropagation()">
        <mat-icon>category</mat-icon>{{ 'DMS.PDFTOOLS.SHAPES' | translate }}<mat-icon class="aca-pdfmenu__chev">chevron_right</mat-icon>
        <span class="aca-pdfmenu__sub">
          <button type="button" (click)="arm('shape-rect')"><mat-icon>rectangle</mat-icon>{{ 'DMS.PDFTOOLS.SH_RECT' | translate }}</button>
          <button type="button" (click)="arm('shape-ellipse')"><mat-icon>circle</mat-icon>{{ 'DMS.PDFTOOLS.SH_ELLIPSE' | translate }}</button>
          <button type="button" (click)="arm('shape-line')"><mat-icon>remove</mat-icon>{{ 'DMS.PDFTOOLS.SH_LINE' | translate }}</button>
          <button type="button" (click)="arm('shape-arrow')"><mat-icon>arrow_forward</mat-icon>{{ 'DMS.PDFTOOLS.SH_ARROW' | translate }}</button>
        </span>
      </button>
      <button type="button" class="aca-pdfmenu__has-sub" (click)="$event.stopPropagation()">
        <mat-icon>approval</mat-icon>{{ 'DMS.PDFTOOLS.STAMP' | translate }}<mat-icon class="aca-pdfmenu__chev">chevron_right</mat-icon>
        <span class="aca-pdfmenu__sub">
          <button type="button" *ngFor="let s of stamps" (click)="armStamp(s)"><mat-icon>approval</mat-icon>{{ s }}</button>
        </span>
      </button>

      <h4>{{ 'DMS.PDFTOOLS.G_EDIT' | translate }}</h4>
      <button type="button" (click)="arm('edit-text')"><mat-icon>edit</mat-icon>{{ 'DMS.PDFTOOLS.EDIT_TEXT' | translate }}</button>
      <button type="button" (click)="arm('add-text')"><mat-icon>text_increase</mat-icon>{{ 'DMS.PDFTOOLS.ADD_TEXT' | translate }}</button>
      <button type="button" (click)="arm('edit-image')"><mat-icon>image</mat-icon>{{ 'DMS.PDFTOOLS.EDIT_IMAGE' | translate }}</button>
      <button type="button" (click)="arm('add-image')"><mat-icon>add_photo_alternate</mat-icon>{{ 'DMS.PDFTOOLS.ADD_IMAGE' | translate }}</button>

      <h4>{{ 'DMS.PDFTOOLS.G_SIGN' | translate }}</h4>
      <button type="button" (click)="openSignPad()"><mat-icon>gesture</mat-icon>{{ 'DMS.PDFTOOLS.SIGN' | translate }}</button>
      <button type="button" (click)="startDigitalSign()" [disabled]="busy()">
        <mat-icon>verified_user</mat-icon>{{ 'DMS.PDFTOOLS.SIGN_DIGITAL' | translate }}
      </button>
    </div>

    <div class="aca-pdfmenu__col">
      <h4>{{ 'DMS.PDFTOOLS.G_PAGES' | translate }}</h4>
      <button type="button" (click)="insertPage()"><mat-icon>note_add</mat-icon>{{ 'DMS.PDFTOOLS.P_INSERT' | translate }}</button>
      <button type="button" (click)="deletePage()"><mat-icon>delete_outline</mat-icon>{{ 'DMS.PDFTOOLS.P_DELETE' | translate }}</button>
      <button type="button" (click)="toolsOpen.set(false)"><mat-icon>swap_vert</mat-icon>{{ 'DMS.PDFTOOLS.P_MOVE' | translate }}</button>
      <button type="button" (click)="rotatePage()"><mat-icon>rotate_90_degrees_cw</mat-icon>{{ 'DMS.PDFTOOLS.P_ROTATE' | translate }}</button>
      <button type="button" (click)="arm('crop')"><mat-icon>crop</mat-icon>{{ 'DMS.PDFTOOLS.P_CROP' | translate }}</button>
      <button type="button" (click)="replacePageAsk()"><mat-icon>find_replace</mat-icon>{{ 'DMS.PDFTOOLS.P_REPLACE' | translate }}</button>
      <button type="button" (click)="extractPage()"><mat-icon>call_split</mat-icon>{{ 'DMS.PDFTOOLS.P_EXTRACT' | translate }}</button>

      <h4>{{ 'DMS.PDFTOOLS.G_FORM' | translate }}</h4>
      <button type="button" (click)="arm('field-text')"><mat-icon>text_fields</mat-icon>{{ 'DMS.PDFTOOLS.F_TEXT' | translate }}</button>
      <button type="button" (click)="arm('field-check')"><mat-icon>check_box</mat-icon>{{ 'DMS.PDFTOOLS.F_CHECK' | translate }}</button>
      <button type="button" (click)="arm('field-radio')"><mat-icon>radio_button_checked</mat-icon>{{ 'DMS.PDFTOOLS.F_RADIO' | translate }}</button>
      <button type="button" (click)="arm('field-dropdown')">
        <mat-icon>arrow_drop_down_circle</mat-icon>{{ 'DMS.PDFTOOLS.F_DROPDOWN' | translate }}
      </button>
      <button type="button" (click)="arm('sign-field')"><mat-icon>draw</mat-icon>{{ 'DMS.PDFTOOLS.F_SIGN' | translate }}</button>

      <h4>{{ 'DMS.PDFTOOLS.G_REDACT' | translate }}</h4>
      <button type="button" (click)="arm('redact')"><mat-icon>visibility_off</mat-icon>{{ 'DMS.PDFTOOLS.R_MARK' | translate }}</button>
      <button type="button" [disabled]="scanning()" [matTooltip]="'DMS.PDFTOOLS.PII_HINT' | translate" (click)="findPersonalData()">
        <mat-icon>privacy_tip</mat-icon>{{ (scanning() ? 'DMS.PDFTOOLS.PII_BUSY' : 'DMS.PDFTOOLS.PII_FIND') | translate }}
      </button>
      <button type="button" (click)="applyRedact()"><mat-icon>lock</mat-icon>{{ 'DMS.PDFTOOLS.R_APPLY' | translate }}</button>
    </div>
  </div>

  <!-- body: thumbnails | pages -->
  <div class="aca-pdfstudio__body">
    <aside class="aca-pdfstudio__rail" *ngIf="railOpen()">
      <div class="aca-pdfstudio__railhead">
        <span>{{ 'DMS.PDFTOOLS.PAGES' | translate }}</span>
        <button mat-icon-button (click)="railOpen.set(false)"><mat-icon>close</mat-icon></button>
      </div>
      <div class="aca-pdfstudio__thumbs" #rail></div>
    </aside>

    <div
      class="aca-pdfstudio__scroll"
      #scroller
      [class.aca-pdfstudio__scroll--pan]="isTool('pan')"
      [class.aca-pdfstudio__scroll--markup]="isTool('highlight', 'underline', 'strike')"
    >
      <button
        type="button"
        class="aca-pdfstudio__armed"
        *ngIf="armedTool() as at"
        (click)="arm('select')"
        [matTooltip]="'DMS.PDFTOOLS.HINT_OFF' | translate"
      >
        <mat-icon>{{ at.icon }}</mat-icon>
        <strong>{{ at.label }}</strong>
        <em>{{ at.hint }}</em>
        <mat-icon class="aca-pdfstudio__armed-x">close</mat-icon>
      </button>
      <div class="aca-pdfstudio__stage" #stage></div>
      <p class="aca-pdfstudio__loading" *ngIf="loading()">
        <mat-icon class="aca-pdfstudio__spin">progress_activity</mat-icon>{{ 'DMS.PDFTOOLS.LOADING' | translate }}
      </p>
      <p class="aca-pdfstudio__loading" *ngIf="failed()"><mat-icon>error_outline</mat-icon>{{ 'DMS.PDFTOOLS.FAILED' | translate }}</p>
    </div>
  </div>

  <!-- bottom bar -->
  <div class="aca-pdfstudio__status">
    <button mat-icon-button (click)="nextPage(-1)" [disabled]="currentPage() <= 1"><mat-icon>chevron_left</mat-icon></button>
    <span class="aca-pdfstudio__pageno">{{ currentPage() }} / {{ pageCount() }}</span>
    <button mat-icon-button (click)="nextPage(1)" [disabled]="currentPage() >= pageCount()"><mat-icon>chevron_right</mat-icon></button>
    <span class="aca-pdfstudio__flex"></span>
    <button mat-icon-button (click)="zoomOut()"><mat-icon>zoom_out</mat-icon></button>
    <button type="button" class="aca-pdfstudio__zoomval" [matMenuTriggerFor]="zoomMenu2">{{ zoom() * 100 | number: '1.0-0' }}%</button>
    <mat-menu #zoomMenu2="matMenu">
      <button mat-menu-item *ngFor="let z of [0.5, 0.75, 1, 1.25, 1.5, 2]" (click)="setZoom(z)">{{ z * 100 }}%</button>
    </mat-menu>
    <button mat-icon-button (click)="zoomIn()"><mat-icon>zoom_in</mat-icon></button>
    <button
      mat-icon-button
      (click)="railOpen.set(!railOpen())"
      [matTooltip]="'DMS.PDFTOOLS.PAGES' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.PAGES' | translate"
    >
      <mat-icon>vertical_split</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="deleteSelected()"
      [disabled]="!selectedAnnot() && !selectedField()"
      [matTooltip]="'DMS.PDFTOOLS.DELETE_MARK' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.DELETE_MARK' | translate"
    >
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>

  <!-- click-placed text editor -->
  <div class="aca-pdfpop" #pdfpop *ngIf="popup() as pop" [style.left.px]="pop.sx" [style.top.px]="pop.sy">
    <div class="aca-pdfpop__head">
      <span class="aca-pdfpop__badge" [ngClass]="'aca-pdfpop__badge--' + pop.kind"
        ><mat-icon>{{ popupIcon(pop) }}</mat-icon></span
      >
      <span class="aca-pdfpop__title">{{ popupTitle(pop) }}</span>
      <button mat-icon-button type="button" class="aca-pdfpop__close" (click)="cancelPopup()"><mat-icon>close</mat-icon></button>
    </div>
    <textarea
      [(ngModel)]="pop.text"
      rows="3"
      [placeholder]="'DMS.PDFTOOLS.TEXT_PH' | translate"
      [attr.aria-label]="'DMS.PDFTOOLS.TEXT_PH' | translate"
      (keydown)="popupKeydown($event)"
    ></textarea>
    <div class="aca-pdfpop__foot">
      <button *ngIf="pop.editId" mat-button color="warn" type="button" class="aca-pdfpop__delete" (click)="deletePopupMark()">
        <mat-icon>delete_outline</mat-icon>{{ 'DMS.PDFTOOLS.DELETE_MARK' | translate }}
      </button>
      <span class="aca-pdfpop__hint">{{ 'DMS.PDFTOOLS.POPUP_HINT' | translate }}</span>
      <button mat-button type="button" (click)="cancelPopup()">{{ 'DMS.MENUPERM.CANCEL' | translate }}</button>
      <button mat-flat-button color="primary" type="button" (click)="confirmPopup()">{{ 'DMS.MENUPERM.SAVE' | translate }}</button>
    </div>
  </div>

  <!-- signature pad -->
  <div class="aca-pdfsign" *ngIf="signPadOpen()">
    <div class="aca-pdfsign__card">
      <h3>{{ 'DMS.PDFTOOLS.SIGN' | translate }}</h3>
      <canvas #signPad width="420" height="160"></canvas>
      <div class="aca-pdfsign__actions">
        <button mat-button type="button" (click)="clearSignPad()">{{ 'DMS.PDFTOOLS.SIGN_CLEAR' | translate }}</button>
        <span class="aca-pdfstudio__flex"></span>
        <button mat-button type="button" (click)="cancelSignPad()">{{ 'DMS.MENUPERM.CANCEL' | translate }}</button>
        <button mat-flat-button color="primary" type="button" (click)="confirmSignPad()">{{ 'DMS.PDFTOOLS.SIGN_OK' | translate }}</button>
      </div>
    </div>
  </div>

  <input type="file" #imagePick accept="image/png,image/jpeg" hidden (change)="onImagePicked($event)" />
  <input type="file" #pdfPick accept="application/pdf" hidden (change)="onPdfPicked($event)" />
</div>
